/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {ConnectorData} from '../bioplanModels';
// @ts-ignore
import type {EstimatedNetValue} from '../bioplanModels';
// @ts-ignore
import type {Kpi} from '../bioplanModels';
// @ts-ignore
import type {MABUtilizationPerConcession} from '../bioplanModels';
// @ts-ignore
import type {MABUtilizationPerPlan} from '../bioplanModels';
// @ts-ignore
import type {Timeline} from '../bioplanModels';
/**
 * KPIsKeyPerformanceIndicatorsApi - axios parameter creator
 * @export
 */
export const KPIsKeyPerformanceIndicatorsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get concession allocation report as Excel file.
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cageAllocationPerConcessionGet: async (
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('cageAllocationPerConcessionGet', 'planId', planId);
      const localVarPath = `/CageAllocationPerConcession`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get plan data in a flat format suitable for plotting in a pivot table.
     * @param {string} planId
     * @param {DataReportPlanIdGetGroupByEnum} [groupBy]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataReportPlanIdGet: async (
      planId: string,
      groupBy?: DataReportPlanIdGetGroupByEnum,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('dataReportPlanIdGet', 'planId', planId);
      const localVarPath = `/dataReport/{planId}`.replace(`{${'planId'}}`, encodeURIComponent(String(planId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (groupBy !== undefined) {
        localVarQueryParameter['groupBy'] = groupBy;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataReportPlanIdPut: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('dataReportPlanIdPut', 'planId', planId);
      const localVarPath = `/dataReport/{planId}`.replace(`{${'planId'}}`, encodeURIComponent(String(planId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get estimated net value for biomass in date interval. Value will be calculated for harvests and for remaining biomass at the end of interval.
     * @param {string} planId
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    estimatedNetValueGet: async (
      planId: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('estimatedNetValueGet', 'planId', planId);
      const localVarPath = `/estimatedNetValue`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Multiple plan IDs can be sent.
     * @summary Get harvest volume for plans. Can be grouped by day, week (default), month, or year. Request can be filtered by start and end date.
     * @param {Array<string>} planId
     * @param {string} startDate
     * @param {string} endDate
     * @param {HarvestTimelineGetGroupByEnum} [groupBy]
     * @param {Array<HarvestTimelineGetSpeciesEnum>} [species]
     * @param {Array<HarvestTimelineGetCertificatesEnum>} [certificates]
     * @param {Array<string>} [siteNames]
     * @param {Array<string>} [cageNames]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestTimelineGet: async (
      planId: Array<string>,
      startDate: string,
      endDate: string,
      groupBy?: HarvestTimelineGetGroupByEnum,
      species?: Array<HarvestTimelineGetSpeciesEnum>,
      certificates?: Array<HarvestTimelineGetCertificatesEnum>,
      siteNames?: Array<string>,
      cageNames?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('harvestTimelineGet', 'planId', planId);
      // verify required parameter 'startDate' is not null or undefined
      assertParamExists('harvestTimelineGet', 'startDate', startDate);
      // verify required parameter 'endDate' is not null or undefined
      assertParamExists('harvestTimelineGet', 'endDate', endDate);
      const localVarPath = `/harvestTimeline`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId) {
        localVarQueryParameter['planId'] = planId;
      }

      if (groupBy !== undefined) {
        localVarQueryParameter['groupBy'] = groupBy;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      if (species) {
        localVarQueryParameter['species'] = species;
      }

      if (certificates) {
        localVarQueryParameter['certificates'] = certificates;
      }

      if (siteNames) {
        localVarQueryParameter['siteNames'] = siteNames;
      }

      if (cageNames) {
        localVarQueryParameter['cageNames'] = cageNames;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Multiple plan IDs can be sent.
     * @summary Get input timeline for plans. Can be grouped by day, week (default), month, or year. Request can be filtered by start and end date.
     * @param {Array<string>} planId
     * @param {string} startDate
     * @param {string} endDate
     * @param {InputTimelineGetGroupByEnum} [groupBy]
     * @param {Array<InputTimelineGetSpeciesEnum>} [species]
     * @param {Array<InputTimelineGetCertificatesEnum>} [certificates]
     * @param {Array<string>} [siteNames]
     * @param {Array<string>} [cageNames]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputTimelineGet: async (
      planId: Array<string>,
      startDate: string,
      endDate: string,
      groupBy?: InputTimelineGetGroupByEnum,
      species?: Array<InputTimelineGetSpeciesEnum>,
      certificates?: Array<InputTimelineGetCertificatesEnum>,
      siteNames?: Array<string>,
      cageNames?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('inputTimelineGet', 'planId', planId);
      // verify required parameter 'startDate' is not null or undefined
      assertParamExists('inputTimelineGet', 'startDate', startDate);
      // verify required parameter 'endDate' is not null or undefined
      assertParamExists('inputTimelineGet', 'endDate', endDate);
      const localVarPath = `/inputTimeline`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId) {
        localVarQueryParameter['planId'] = planId;
      }

      if (groupBy !== undefined) {
        localVarQueryParameter['groupBy'] = groupBy;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      if (species) {
        localVarQueryParameter['species'] = species;
      }

      if (certificates) {
        localVarQueryParameter['certificates'] = certificates;
      }

      if (siteNames) {
        localVarQueryParameter['siteNames'] = siteNames;
      }

      if (cageNames) {
        localVarQueryParameter['cageNames'] = cageNames;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Data field in response is a mixed list of integer, float, string, and dict[float].  Production performance KPI - total harvest volume (kg) - average harvest weight (kg) - harvest size distribution (fraction per weight class, kg) - concession utilization (%)  Financial KPI - Expected revenue (NOK)
     * @summary Get KPIs for plans. Request can be filtered by start and end date. Multiple plan IDs can be sent.
     * @param {Array<string>} planId
     * @param {string} startDate
     * @param {string} endDate
     * @param {KpiGetGroupByEnum} [groupBy]
     * @param {Array<KpiGetColumnsEnum>} [columns]
     * @param {Array<string>} [siteNames]
     * @param {Array<string>} [cageNames]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    kpiGet: async (
      planId: Array<string>,
      startDate: string,
      endDate: string,
      groupBy?: KpiGetGroupByEnum,
      columns?: Array<KpiGetColumnsEnum>,
      siteNames?: Array<string>,
      cageNames?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('kpiGet', 'planId', planId);
      // verify required parameter 'startDate' is not null or undefined
      assertParamExists('kpiGet', 'startDate', startDate);
      // verify required parameter 'endDate' is not null or undefined
      assertParamExists('kpiGet', 'endDate', endDate);
      const localVarPath = `/kpi`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId) {
        localVarQueryParameter['planId'] = planId;
      }

      if (groupBy !== undefined) {
        localVarQueryParameter['groupBy'] = groupBy;
      }

      if (columns) {
        localVarQueryParameter['columns'] = columns;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      if (siteNames) {
        localVarQueryParameter['siteNames'] = siteNames;
      }

      if (cageNames) {
        localVarQueryParameter['cageNames'] = cageNames;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Multiple plan IDs can be sent.
     * @summary Get total MAB utilization (without distinction between different concessions) for plans. Can be grouped by day, week (default), month, or year. Request can be filtered by start and end date.
     * @param {Array<string>} planId
     * @param {string} startDate
     * @param {string} endDate
     * @param {MABUtilizationGetGroupByEnum} [groupBy]
     * @param {Array<MABUtilizationGetColumnsEnum>} [columns]
     * @param {Array<string>} [siteNames]
     * @param {Array<string>} [cageNames]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mABUtilizationGet: async (
      planId: Array<string>,
      startDate: string,
      endDate: string,
      groupBy?: MABUtilizationGetGroupByEnum,
      columns?: Array<MABUtilizationGetColumnsEnum>,
      siteNames?: Array<string>,
      cageNames?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('mABUtilizationGet', 'planId', planId);
      // verify required parameter 'startDate' is not null or undefined
      assertParamExists('mABUtilizationGet', 'startDate', startDate);
      // verify required parameter 'endDate' is not null or undefined
      assertParamExists('mABUtilizationGet', 'endDate', endDate);
      const localVarPath = `/MABUtilization`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId) {
        localVarQueryParameter['planId'] = planId;
      }

      if (groupBy !== undefined) {
        localVarQueryParameter['groupBy'] = groupBy;
      }

      if (columns) {
        localVarQueryParameter['columns'] = columns;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      if (siteNames) {
        localVarQueryParameter['siteNames'] = siteNames;
      }

      if (cageNames) {
        localVarQueryParameter['cageNames'] = cageNames;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Multiple concession IDs can be sent.
     * @summary Get MAB utilization for concessions. Can be grouped by day, week (default), month, or year. Request can be filtered by start and end date.
     * @param {Array<string>} concessions
     * @param {MABUtilizationPerConcessionGetGroupByEnum} [groupBy]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mABUtilizationPerConcessionGet: async (
      concessions: Array<string>,
      groupBy?: MABUtilizationPerConcessionGetGroupByEnum,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'concessions' is not null or undefined
      assertParamExists('mABUtilizationPerConcessionGet', 'concessions', concessions);
      const localVarPath = `/MABUtilizationPerConcession`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (concessions) {
        localVarQueryParameter['concessions'] = concessions;
      }

      if (groupBy !== undefined) {
        localVarQueryParameter['groupBy'] = groupBy;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * KPIsKeyPerformanceIndicatorsApi - functional programming interface
 * @export
 */
export const KPIsKeyPerformanceIndicatorsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = KPIsKeyPerformanceIndicatorsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get concession allocation report as Excel file.
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cageAllocationPerConcessionGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cageAllocationPerConcessionGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['KPIsKeyPerformanceIndicatorsApi.cageAllocationPerConcessionGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get plan data in a flat format suitable for plotting in a pivot table.
     * @param {string} planId
     * @param {DataReportPlanIdGetGroupByEnum} [groupBy]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataReportPlanIdGet(
      planId: string,
      groupBy?: DataReportPlanIdGetGroupByEnum,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectorData>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dataReportPlanIdGet(
        planId,
        groupBy,
        startDate,
        endDate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['KPIsKeyPerformanceIndicatorsApi.dataReportPlanIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataReportPlanIdPut(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dataReportPlanIdPut(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['KPIsKeyPerformanceIndicatorsApi.dataReportPlanIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get estimated net value for biomass in date interval. Value will be calculated for harvests and for remaining biomass at the end of interval.
     * @param {string} planId
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async estimatedNetValueGet(
      planId: string,
      endDate?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EstimatedNetValue>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.estimatedNetValueGet(planId, endDate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['KPIsKeyPerformanceIndicatorsApi.estimatedNetValueGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Multiple plan IDs can be sent.
     * @summary Get harvest volume for plans. Can be grouped by day, week (default), month, or year. Request can be filtered by start and end date.
     * @param {Array<string>} planId
     * @param {string} startDate
     * @param {string} endDate
     * @param {HarvestTimelineGetGroupByEnum} [groupBy]
     * @param {Array<HarvestTimelineGetSpeciesEnum>} [species]
     * @param {Array<HarvestTimelineGetCertificatesEnum>} [certificates]
     * @param {Array<string>} [siteNames]
     * @param {Array<string>} [cageNames]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestTimelineGet(
      planId: Array<string>,
      startDate: string,
      endDate: string,
      groupBy?: HarvestTimelineGetGroupByEnum,
      species?: Array<HarvestTimelineGetSpeciesEnum>,
      certificates?: Array<HarvestTimelineGetCertificatesEnum>,
      siteNames?: Array<string>,
      cageNames?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Timeline>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestTimelineGet(
        planId,
        startDate,
        endDate,
        groupBy,
        species,
        certificates,
        siteNames,
        cageNames,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['KPIsKeyPerformanceIndicatorsApi.harvestTimelineGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Multiple plan IDs can be sent.
     * @summary Get input timeline for plans. Can be grouped by day, week (default), month, or year. Request can be filtered by start and end date.
     * @param {Array<string>} planId
     * @param {string} startDate
     * @param {string} endDate
     * @param {InputTimelineGetGroupByEnum} [groupBy]
     * @param {Array<InputTimelineGetSpeciesEnum>} [species]
     * @param {Array<InputTimelineGetCertificatesEnum>} [certificates]
     * @param {Array<string>} [siteNames]
     * @param {Array<string>} [cageNames]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inputTimelineGet(
      planId: Array<string>,
      startDate: string,
      endDate: string,
      groupBy?: InputTimelineGetGroupByEnum,
      species?: Array<InputTimelineGetSpeciesEnum>,
      certificates?: Array<InputTimelineGetCertificatesEnum>,
      siteNames?: Array<string>,
      cageNames?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Timeline>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inputTimelineGet(
        planId,
        startDate,
        endDate,
        groupBy,
        species,
        certificates,
        siteNames,
        cageNames,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['KPIsKeyPerformanceIndicatorsApi.inputTimelineGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Data field in response is a mixed list of integer, float, string, and dict[float].  Production performance KPI - total harvest volume (kg) - average harvest weight (kg) - harvest size distribution (fraction per weight class, kg) - concession utilization (%)  Financial KPI - Expected revenue (NOK)
     * @summary Get KPIs for plans. Request can be filtered by start and end date. Multiple plan IDs can be sent.
     * @param {Array<string>} planId
     * @param {string} startDate
     * @param {string} endDate
     * @param {KpiGetGroupByEnum} [groupBy]
     * @param {Array<KpiGetColumnsEnum>} [columns]
     * @param {Array<string>} [siteNames]
     * @param {Array<string>} [cageNames]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async kpiGet(
      planId: Array<string>,
      startDate: string,
      endDate: string,
      groupBy?: KpiGetGroupByEnum,
      columns?: Array<KpiGetColumnsEnum>,
      siteNames?: Array<string>,
      cageNames?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Kpi>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.kpiGet(
        planId,
        startDate,
        endDate,
        groupBy,
        columns,
        siteNames,
        cageNames,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['KPIsKeyPerformanceIndicatorsApi.kpiGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Multiple plan IDs can be sent.
     * @summary Get total MAB utilization (without distinction between different concessions) for plans. Can be grouped by day, week (default), month, or year. Request can be filtered by start and end date.
     * @param {Array<string>} planId
     * @param {string} startDate
     * @param {string} endDate
     * @param {MABUtilizationGetGroupByEnum} [groupBy]
     * @param {Array<MABUtilizationGetColumnsEnum>} [columns]
     * @param {Array<string>} [siteNames]
     * @param {Array<string>} [cageNames]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mABUtilizationGet(
      planId: Array<string>,
      startDate: string,
      endDate: string,
      groupBy?: MABUtilizationGetGroupByEnum,
      columns?: Array<MABUtilizationGetColumnsEnum>,
      siteNames?: Array<string>,
      cageNames?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MABUtilizationPerPlan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mABUtilizationGet(
        planId,
        startDate,
        endDate,
        groupBy,
        columns,
        siteNames,
        cageNames,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['KPIsKeyPerformanceIndicatorsApi.mABUtilizationGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Multiple concession IDs can be sent.
     * @summary Get MAB utilization for concessions. Can be grouped by day, week (default), month, or year. Request can be filtered by start and end date.
     * @param {Array<string>} concessions
     * @param {MABUtilizationPerConcessionGetGroupByEnum} [groupBy]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mABUtilizationPerConcessionGet(
      concessions: Array<string>,
      groupBy?: MABUtilizationPerConcessionGetGroupByEnum,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MABUtilizationPerConcession>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mABUtilizationPerConcessionGet(
        concessions,
        groupBy,
        startDate,
        endDate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['KPIsKeyPerformanceIndicatorsApi.mABUtilizationPerConcessionGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * KPIsKeyPerformanceIndicatorsApi - factory interface
 * @export
 */
export const KPIsKeyPerformanceIndicatorsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = KPIsKeyPerformanceIndicatorsApiFp(configuration);
  return {
    /**
     *
     * @summary Get concession allocation report as Excel file.
     * @param {KPIsKeyPerformanceIndicatorsApiCageAllocationPerConcessionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cageAllocationPerConcessionGet(
      requestParameters: KPIsKeyPerformanceIndicatorsApiCageAllocationPerConcessionGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<File> {
      return localVarFp
        .cageAllocationPerConcessionGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get plan data in a flat format suitable for plotting in a pivot table.
     * @param {KPIsKeyPerformanceIndicatorsApiDataReportPlanIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataReportPlanIdGet(
      requestParameters: KPIsKeyPerformanceIndicatorsApiDataReportPlanIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ConnectorData> {
      return localVarFp
        .dataReportPlanIdGet(
          requestParameters.planId,
          requestParameters.groupBy,
          requestParameters.startDate,
          requestParameters.endDate,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {KPIsKeyPerformanceIndicatorsApiDataReportPlanIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataReportPlanIdPut(
      requestParameters: KPIsKeyPerformanceIndicatorsApiDataReportPlanIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .dataReportPlanIdPut(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get estimated net value for biomass in date interval. Value will be calculated for harvests and for remaining biomass at the end of interval.
     * @param {KPIsKeyPerformanceIndicatorsApiEstimatedNetValueGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    estimatedNetValueGet(
      requestParameters: KPIsKeyPerformanceIndicatorsApiEstimatedNetValueGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<EstimatedNetValue> {
      return localVarFp
        .estimatedNetValueGet(requestParameters.planId, requestParameters.endDate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Multiple plan IDs can be sent.
     * @summary Get harvest volume for plans. Can be grouped by day, week (default), month, or year. Request can be filtered by start and end date.
     * @param {KPIsKeyPerformanceIndicatorsApiHarvestTimelineGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestTimelineGet(
      requestParameters: KPIsKeyPerformanceIndicatorsApiHarvestTimelineGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Timeline> {
      return localVarFp
        .harvestTimelineGet(
          requestParameters.planId,
          requestParameters.startDate,
          requestParameters.endDate,
          requestParameters.groupBy,
          requestParameters.species,
          requestParameters.certificates,
          requestParameters.siteNames,
          requestParameters.cageNames,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Multiple plan IDs can be sent.
     * @summary Get input timeline for plans. Can be grouped by day, week (default), month, or year. Request can be filtered by start and end date.
     * @param {KPIsKeyPerformanceIndicatorsApiInputTimelineGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inputTimelineGet(
      requestParameters: KPIsKeyPerformanceIndicatorsApiInputTimelineGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Timeline> {
      return localVarFp
        .inputTimelineGet(
          requestParameters.planId,
          requestParameters.startDate,
          requestParameters.endDate,
          requestParameters.groupBy,
          requestParameters.species,
          requestParameters.certificates,
          requestParameters.siteNames,
          requestParameters.cageNames,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Data field in response is a mixed list of integer, float, string, and dict[float].  Production performance KPI - total harvest volume (kg) - average harvest weight (kg) - harvest size distribution (fraction per weight class, kg) - concession utilization (%)  Financial KPI - Expected revenue (NOK)
     * @summary Get KPIs for plans. Request can be filtered by start and end date. Multiple plan IDs can be sent.
     * @param {KPIsKeyPerformanceIndicatorsApiKpiGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    kpiGet(
      requestParameters: KPIsKeyPerformanceIndicatorsApiKpiGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Kpi> {
      return localVarFp
        .kpiGet(
          requestParameters.planId,
          requestParameters.startDate,
          requestParameters.endDate,
          requestParameters.groupBy,
          requestParameters.columns,
          requestParameters.siteNames,
          requestParameters.cageNames,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Multiple plan IDs can be sent.
     * @summary Get total MAB utilization (without distinction between different concessions) for plans. Can be grouped by day, week (default), month, or year. Request can be filtered by start and end date.
     * @param {KPIsKeyPerformanceIndicatorsApiMABUtilizationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mABUtilizationGet(
      requestParameters: KPIsKeyPerformanceIndicatorsApiMABUtilizationGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<MABUtilizationPerPlan> {
      return localVarFp
        .mABUtilizationGet(
          requestParameters.planId,
          requestParameters.startDate,
          requestParameters.endDate,
          requestParameters.groupBy,
          requestParameters.columns,
          requestParameters.siteNames,
          requestParameters.cageNames,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Multiple concession IDs can be sent.
     * @summary Get MAB utilization for concessions. Can be grouped by day, week (default), month, or year. Request can be filtered by start and end date.
     * @param {KPIsKeyPerformanceIndicatorsApiMABUtilizationPerConcessionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mABUtilizationPerConcessionGet(
      requestParameters: KPIsKeyPerformanceIndicatorsApiMABUtilizationPerConcessionGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<MABUtilizationPerConcession> {
      return localVarFp
        .mABUtilizationPerConcessionGet(
          requestParameters.concessions,
          requestParameters.groupBy,
          requestParameters.startDate,
          requestParameters.endDate,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for cageAllocationPerConcessionGet operation in KPIsKeyPerformanceIndicatorsApi.
 * @export
 * @interface KPIsKeyPerformanceIndicatorsApiCageAllocationPerConcessionGetRequest
 */
export interface KPIsKeyPerformanceIndicatorsApiCageAllocationPerConcessionGetRequest {
  /**
   *
   * @type {string}
   * @memberof KPIsKeyPerformanceIndicatorsApiCageAllocationPerConcessionGet
   */
  readonly planId: string;
}

/**
 * Request parameters for dataReportPlanIdGet operation in KPIsKeyPerformanceIndicatorsApi.
 * @export
 * @interface KPIsKeyPerformanceIndicatorsApiDataReportPlanIdGetRequest
 */
export interface KPIsKeyPerformanceIndicatorsApiDataReportPlanIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof KPIsKeyPerformanceIndicatorsApiDataReportPlanIdGet
   */
  readonly planId: string;

  /**
   *
   * @type {'day' | 'week' | 'month' | 'quarter' | 'year'}
   * @memberof KPIsKeyPerformanceIndicatorsApiDataReportPlanIdGet
   */
  readonly groupBy?: DataReportPlanIdGetGroupByEnum;

  /**
   *
   * @type {string}
   * @memberof KPIsKeyPerformanceIndicatorsApiDataReportPlanIdGet
   */
  readonly startDate?: string;

  /**
   *
   * @type {string}
   * @memberof KPIsKeyPerformanceIndicatorsApiDataReportPlanIdGet
   */
  readonly endDate?: string;
}

/**
 * Request parameters for dataReportPlanIdPut operation in KPIsKeyPerformanceIndicatorsApi.
 * @export
 * @interface KPIsKeyPerformanceIndicatorsApiDataReportPlanIdPutRequest
 */
export interface KPIsKeyPerformanceIndicatorsApiDataReportPlanIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof KPIsKeyPerformanceIndicatorsApiDataReportPlanIdPut
   */
  readonly planId: string;
}

/**
 * Request parameters for estimatedNetValueGet operation in KPIsKeyPerformanceIndicatorsApi.
 * @export
 * @interface KPIsKeyPerformanceIndicatorsApiEstimatedNetValueGetRequest
 */
export interface KPIsKeyPerformanceIndicatorsApiEstimatedNetValueGetRequest {
  /**
   *
   * @type {string}
   * @memberof KPIsKeyPerformanceIndicatorsApiEstimatedNetValueGet
   */
  readonly planId: string;

  /**
   *
   * @type {string}
   * @memberof KPIsKeyPerformanceIndicatorsApiEstimatedNetValueGet
   */
  readonly endDate?: string;
}

/**
 * Request parameters for harvestTimelineGet operation in KPIsKeyPerformanceIndicatorsApi.
 * @export
 * @interface KPIsKeyPerformanceIndicatorsApiHarvestTimelineGetRequest
 */
export interface KPIsKeyPerformanceIndicatorsApiHarvestTimelineGetRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof KPIsKeyPerformanceIndicatorsApiHarvestTimelineGet
   */
  readonly planId: Array<string>;

  /**
   *
   * @type {string}
   * @memberof KPIsKeyPerformanceIndicatorsApiHarvestTimelineGet
   */
  readonly startDate: string;

  /**
   *
   * @type {string}
   * @memberof KPIsKeyPerformanceIndicatorsApiHarvestTimelineGet
   */
  readonly endDate: string;

  /**
   *
   * @type {'day' | 'week' | 'month' | 'quarter' | 'year' | 'null'}
   * @memberof KPIsKeyPerformanceIndicatorsApiHarvestTimelineGet
   */
  readonly groupBy?: HarvestTimelineGetGroupByEnum;

  /**
   *
   * @type {Array<'salmon' | 'trout'>}
   * @memberof KPIsKeyPerformanceIndicatorsApiHarvestTimelineGet
   */
  readonly species?: Array<HarvestTimelineGetSpeciesEnum>;

  /**
   *
   * @type {Array<'ASC' | 'Debio' | 'FOS' | 'GlobalGAP' | 'Naturland' | 'Organic' | 'Practice_GAABAP' | 'SoilAssociation' | 'Gladlaks' | 'STP'>}
   * @memberof KPIsKeyPerformanceIndicatorsApiHarvestTimelineGet
   */
  readonly certificates?: Array<HarvestTimelineGetCertificatesEnum>;

  /**
   *
   * @type {Array<string>}
   * @memberof KPIsKeyPerformanceIndicatorsApiHarvestTimelineGet
   */
  readonly siteNames?: Array<string>;

  /**
   *
   * @type {Array<string>}
   * @memberof KPIsKeyPerformanceIndicatorsApiHarvestTimelineGet
   */
  readonly cageNames?: Array<string>;
}

/**
 * Request parameters for inputTimelineGet operation in KPIsKeyPerformanceIndicatorsApi.
 * @export
 * @interface KPIsKeyPerformanceIndicatorsApiInputTimelineGetRequest
 */
export interface KPIsKeyPerformanceIndicatorsApiInputTimelineGetRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof KPIsKeyPerformanceIndicatorsApiInputTimelineGet
   */
  readonly planId: Array<string>;

  /**
   *
   * @type {string}
   * @memberof KPIsKeyPerformanceIndicatorsApiInputTimelineGet
   */
  readonly startDate: string;

  /**
   *
   * @type {string}
   * @memberof KPIsKeyPerformanceIndicatorsApiInputTimelineGet
   */
  readonly endDate: string;

  /**
   *
   * @type {'day' | 'week' | 'month' | 'quarter' | 'year' | 'null'}
   * @memberof KPIsKeyPerformanceIndicatorsApiInputTimelineGet
   */
  readonly groupBy?: InputTimelineGetGroupByEnum;

  /**
   *
   * @type {Array<'salmon' | 'trout'>}
   * @memberof KPIsKeyPerformanceIndicatorsApiInputTimelineGet
   */
  readonly species?: Array<InputTimelineGetSpeciesEnum>;

  /**
   *
   * @type {Array<'ASC' | 'Debio' | 'FOS' | 'GlobalGAP' | 'Naturland' | 'Organic' | 'Practice_GAABAP' | 'SoilAssociation' | 'Gladlaks' | 'STP'>}
   * @memberof KPIsKeyPerformanceIndicatorsApiInputTimelineGet
   */
  readonly certificates?: Array<InputTimelineGetCertificatesEnum>;

  /**
   *
   * @type {Array<string>}
   * @memberof KPIsKeyPerformanceIndicatorsApiInputTimelineGet
   */
  readonly siteNames?: Array<string>;

  /**
   *
   * @type {Array<string>}
   * @memberof KPIsKeyPerformanceIndicatorsApiInputTimelineGet
   */
  readonly cageNames?: Array<string>;
}

/**
 * Request parameters for kpiGet operation in KPIsKeyPerformanceIndicatorsApi.
 * @export
 * @interface KPIsKeyPerformanceIndicatorsApiKpiGetRequest
 */
export interface KPIsKeyPerformanceIndicatorsApiKpiGetRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof KPIsKeyPerformanceIndicatorsApiKpiGet
   */
  readonly planId: Array<string>;

  /**
   *
   * @type {string}
   * @memberof KPIsKeyPerformanceIndicatorsApiKpiGet
   */
  readonly startDate: string;

  /**
   *
   * @type {string}
   * @memberof KPIsKeyPerformanceIndicatorsApiKpiGet
   */
  readonly endDate: string;

  /**
   *
   * @type {'day' | 'week' | 'month' | 'quarter' | 'year' | 'null'}
   * @memberof KPIsKeyPerformanceIndicatorsApiKpiGet
   */
  readonly groupBy?: KpiGetGroupByEnum;

  /**
   *
   * @type {Array<'averageHarvestWeight' | 'closingBiomass' | 'days' | 'feedAmount' | 'feedCost' | 'harvestWeight' | 'inputBiomass' | 'inputCount' | 'inputWeight' | 'netGrowth' | 'harvestSizeDistribution' | 'harvestCount' | 'harvestVolumeEbit' | 'harvestVolumeHog' | 'harvestVolumeLwe' | 'harvestWeightHog' | 'harvestWeightLwe' | 'mabUtilization' | 'mortalityCount' | 'turnover'>}
   * @memberof KPIsKeyPerformanceIndicatorsApiKpiGet
   */
  readonly columns?: Array<KpiGetColumnsEnum>;

  /**
   *
   * @type {Array<string>}
   * @memberof KPIsKeyPerformanceIndicatorsApiKpiGet
   */
  readonly siteNames?: Array<string>;

  /**
   *
   * @type {Array<string>}
   * @memberof KPIsKeyPerformanceIndicatorsApiKpiGet
   */
  readonly cageNames?: Array<string>;
}

/**
 * Request parameters for mABUtilizationGet operation in KPIsKeyPerformanceIndicatorsApi.
 * @export
 * @interface KPIsKeyPerformanceIndicatorsApiMABUtilizationGetRequest
 */
export interface KPIsKeyPerformanceIndicatorsApiMABUtilizationGetRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof KPIsKeyPerformanceIndicatorsApiMABUtilizationGet
   */
  readonly planId: Array<string>;

  /**
   *
   * @type {string}
   * @memberof KPIsKeyPerformanceIndicatorsApiMABUtilizationGet
   */
  readonly startDate: string;

  /**
   *
   * @type {string}
   * @memberof KPIsKeyPerformanceIndicatorsApiMABUtilizationGet
   */
  readonly endDate: string;

  /**
   *
   * @type {'day' | 'week' | 'month' | 'quarter' | 'year' | 'null'}
   * @memberof KPIsKeyPerformanceIndicatorsApiMABUtilizationGet
   */
  readonly groupBy?: MABUtilizationGetGroupByEnum;

  /**
   *
   * @type {Array<'averageHarvestWeight' | 'closingBiomass' | 'days' | 'feedAmount' | 'feedCost' | 'harvestWeight' | 'inputBiomass' | 'inputCount' | 'inputWeight' | 'netGrowth' | 'harvestSizeDistribution' | 'harvestCount' | 'harvestVolumeEbit' | 'harvestVolumeHog' | 'harvestVolumeLwe' | 'harvestWeightHog' | 'harvestWeightLwe' | 'mabUtilization' | 'mortalityCount' | 'turnover'>}
   * @memberof KPIsKeyPerformanceIndicatorsApiMABUtilizationGet
   */
  readonly columns?: Array<MABUtilizationGetColumnsEnum>;

  /**
   *
   * @type {Array<string>}
   * @memberof KPIsKeyPerformanceIndicatorsApiMABUtilizationGet
   */
  readonly siteNames?: Array<string>;

  /**
   *
   * @type {Array<string>}
   * @memberof KPIsKeyPerformanceIndicatorsApiMABUtilizationGet
   */
  readonly cageNames?: Array<string>;
}

/**
 * Request parameters for mABUtilizationPerConcessionGet operation in KPIsKeyPerformanceIndicatorsApi.
 * @export
 * @interface KPIsKeyPerformanceIndicatorsApiMABUtilizationPerConcessionGetRequest
 */
export interface KPIsKeyPerformanceIndicatorsApiMABUtilizationPerConcessionGetRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof KPIsKeyPerformanceIndicatorsApiMABUtilizationPerConcessionGet
   */
  readonly concessions: Array<string>;

  /**
   *
   * @type {'day' | 'week' | 'month' | 'year'}
   * @memberof KPIsKeyPerformanceIndicatorsApiMABUtilizationPerConcessionGet
   */
  readonly groupBy?: MABUtilizationPerConcessionGetGroupByEnum;

  /**
   *
   * @type {string}
   * @memberof KPIsKeyPerformanceIndicatorsApiMABUtilizationPerConcessionGet
   */
  readonly startDate?: string;

  /**
   *
   * @type {string}
   * @memberof KPIsKeyPerformanceIndicatorsApiMABUtilizationPerConcessionGet
   */
  readonly endDate?: string;
}

/**
 * KPIsKeyPerformanceIndicatorsApi - object-oriented interface
 * @export
 * @class KPIsKeyPerformanceIndicatorsApi
 * @extends {BaseAPI}
 */
export class KPIsKeyPerformanceIndicatorsApi extends BaseAPI {
  /**
   *
   * @summary Get concession allocation report as Excel file.
   * @param {KPIsKeyPerformanceIndicatorsApiCageAllocationPerConcessionGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KPIsKeyPerformanceIndicatorsApi
   */
  public cageAllocationPerConcessionGet(
    requestParameters: KPIsKeyPerformanceIndicatorsApiCageAllocationPerConcessionGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return KPIsKeyPerformanceIndicatorsApiFp(this.configuration)
      .cageAllocationPerConcessionGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get plan data in a flat format suitable for plotting in a pivot table.
   * @param {KPIsKeyPerformanceIndicatorsApiDataReportPlanIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KPIsKeyPerformanceIndicatorsApi
   */
  public dataReportPlanIdGet(
    requestParameters: KPIsKeyPerformanceIndicatorsApiDataReportPlanIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return KPIsKeyPerformanceIndicatorsApiFp(this.configuration)
      .dataReportPlanIdGet(
        requestParameters.planId,
        requestParameters.groupBy,
        requestParameters.startDate,
        requestParameters.endDate,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {KPIsKeyPerformanceIndicatorsApiDataReportPlanIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KPIsKeyPerformanceIndicatorsApi
   */
  public dataReportPlanIdPut(
    requestParameters: KPIsKeyPerformanceIndicatorsApiDataReportPlanIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return KPIsKeyPerformanceIndicatorsApiFp(this.configuration)
      .dataReportPlanIdPut(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get estimated net value for biomass in date interval. Value will be calculated for harvests and for remaining biomass at the end of interval.
   * @param {KPIsKeyPerformanceIndicatorsApiEstimatedNetValueGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KPIsKeyPerformanceIndicatorsApi
   */
  public estimatedNetValueGet(
    requestParameters: KPIsKeyPerformanceIndicatorsApiEstimatedNetValueGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return KPIsKeyPerformanceIndicatorsApiFp(this.configuration)
      .estimatedNetValueGet(requestParameters.planId, requestParameters.endDate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Multiple plan IDs can be sent.
   * @summary Get harvest volume for plans. Can be grouped by day, week (default), month, or year. Request can be filtered by start and end date.
   * @param {KPIsKeyPerformanceIndicatorsApiHarvestTimelineGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KPIsKeyPerformanceIndicatorsApi
   */
  public harvestTimelineGet(
    requestParameters: KPIsKeyPerformanceIndicatorsApiHarvestTimelineGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return KPIsKeyPerformanceIndicatorsApiFp(this.configuration)
      .harvestTimelineGet(
        requestParameters.planId,
        requestParameters.startDate,
        requestParameters.endDate,
        requestParameters.groupBy,
        requestParameters.species,
        requestParameters.certificates,
        requestParameters.siteNames,
        requestParameters.cageNames,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Multiple plan IDs can be sent.
   * @summary Get input timeline for plans. Can be grouped by day, week (default), month, or year. Request can be filtered by start and end date.
   * @param {KPIsKeyPerformanceIndicatorsApiInputTimelineGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KPIsKeyPerformanceIndicatorsApi
   */
  public inputTimelineGet(
    requestParameters: KPIsKeyPerformanceIndicatorsApiInputTimelineGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return KPIsKeyPerformanceIndicatorsApiFp(this.configuration)
      .inputTimelineGet(
        requestParameters.planId,
        requestParameters.startDate,
        requestParameters.endDate,
        requestParameters.groupBy,
        requestParameters.species,
        requestParameters.certificates,
        requestParameters.siteNames,
        requestParameters.cageNames,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Data field in response is a mixed list of integer, float, string, and dict[float].  Production performance KPI - total harvest volume (kg) - average harvest weight (kg) - harvest size distribution (fraction per weight class, kg) - concession utilization (%)  Financial KPI - Expected revenue (NOK)
   * @summary Get KPIs for plans. Request can be filtered by start and end date. Multiple plan IDs can be sent.
   * @param {KPIsKeyPerformanceIndicatorsApiKpiGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KPIsKeyPerformanceIndicatorsApi
   */
  public kpiGet(requestParameters: KPIsKeyPerformanceIndicatorsApiKpiGetRequest, options?: RawAxiosRequestConfig) {
    return KPIsKeyPerformanceIndicatorsApiFp(this.configuration)
      .kpiGet(
        requestParameters.planId,
        requestParameters.startDate,
        requestParameters.endDate,
        requestParameters.groupBy,
        requestParameters.columns,
        requestParameters.siteNames,
        requestParameters.cageNames,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Multiple plan IDs can be sent.
   * @summary Get total MAB utilization (without distinction between different concessions) for plans. Can be grouped by day, week (default), month, or year. Request can be filtered by start and end date.
   * @param {KPIsKeyPerformanceIndicatorsApiMABUtilizationGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KPIsKeyPerformanceIndicatorsApi
   */
  public mABUtilizationGet(
    requestParameters: KPIsKeyPerformanceIndicatorsApiMABUtilizationGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return KPIsKeyPerformanceIndicatorsApiFp(this.configuration)
      .mABUtilizationGet(
        requestParameters.planId,
        requestParameters.startDate,
        requestParameters.endDate,
        requestParameters.groupBy,
        requestParameters.columns,
        requestParameters.siteNames,
        requestParameters.cageNames,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Multiple concession IDs can be sent.
   * @summary Get MAB utilization for concessions. Can be grouped by day, week (default), month, or year. Request can be filtered by start and end date.
   * @param {KPIsKeyPerformanceIndicatorsApiMABUtilizationPerConcessionGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KPIsKeyPerformanceIndicatorsApi
   */
  public mABUtilizationPerConcessionGet(
    requestParameters: KPIsKeyPerformanceIndicatorsApiMABUtilizationPerConcessionGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return KPIsKeyPerformanceIndicatorsApiFp(this.configuration)
      .mABUtilizationPerConcessionGet(
        requestParameters.concessions,
        requestParameters.groupBy,
        requestParameters.startDate,
        requestParameters.endDate,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const DataReportPlanIdGetGroupByEnum = {
  Day: 'day',
  Week: 'week',
  Month: 'month',
  Quarter: 'quarter',
  Year: 'year',
} as const;
export type DataReportPlanIdGetGroupByEnum =
  (typeof DataReportPlanIdGetGroupByEnum)[keyof typeof DataReportPlanIdGetGroupByEnum];
/**
 * @export
 */
export const HarvestTimelineGetGroupByEnum = {
  Day: 'day',
  Week: 'week',
  Month: 'month',
  Quarter: 'quarter',
  Year: 'year',
} as const;
export type HarvestTimelineGetGroupByEnum =
  (typeof HarvestTimelineGetGroupByEnum)[keyof typeof HarvestTimelineGetGroupByEnum];
/**
 * @export
 */
export const HarvestTimelineGetSpeciesEnum = {
  Salmon: 'salmon',
  Trout: 'trout',
} as const;
export type HarvestTimelineGetSpeciesEnum =
  (typeof HarvestTimelineGetSpeciesEnum)[keyof typeof HarvestTimelineGetSpeciesEnum];
/**
 * @export
 */
export const HarvestTimelineGetCertificatesEnum = {
  Asc: 'ASC',
  Debio: 'Debio',
  Fos: 'FOS',
  GlobalGap: 'GlobalGAP',
  Naturland: 'Naturland',
  Organic: 'Organic',
  PracticeGaabap: 'Practice_GAABAP',
  SoilAssociation: 'SoilAssociation',
  Gladlaks: 'Gladlaks',
  Stp: 'STP',
} as const;
export type HarvestTimelineGetCertificatesEnum =
  (typeof HarvestTimelineGetCertificatesEnum)[keyof typeof HarvestTimelineGetCertificatesEnum];
/**
 * @export
 */
export const InputTimelineGetGroupByEnum = {
  Day: 'day',
  Week: 'week',
  Month: 'month',
  Quarter: 'quarter',
  Year: 'year',
} as const;
export type InputTimelineGetGroupByEnum =
  (typeof InputTimelineGetGroupByEnum)[keyof typeof InputTimelineGetGroupByEnum];
/**
 * @export
 */
export const InputTimelineGetSpeciesEnum = {
  Salmon: 'salmon',
  Trout: 'trout',
} as const;
export type InputTimelineGetSpeciesEnum =
  (typeof InputTimelineGetSpeciesEnum)[keyof typeof InputTimelineGetSpeciesEnum];
/**
 * @export
 */
export const InputTimelineGetCertificatesEnum = {
  Asc: 'ASC',
  Debio: 'Debio',
  Fos: 'FOS',
  GlobalGap: 'GlobalGAP',
  Naturland: 'Naturland',
  Organic: 'Organic',
  PracticeGaabap: 'Practice_GAABAP',
  SoilAssociation: 'SoilAssociation',
  Gladlaks: 'Gladlaks',
  Stp: 'STP',
} as const;
export type InputTimelineGetCertificatesEnum =
  (typeof InputTimelineGetCertificatesEnum)[keyof typeof InputTimelineGetCertificatesEnum];
/**
 * @export
 */
export const KpiGetGroupByEnum = {
  Day: 'day',
  Week: 'week',
  Month: 'month',
  Quarter: 'quarter',
  Year: 'year',
} as const;
export type KpiGetGroupByEnum = (typeof KpiGetGroupByEnum)[keyof typeof KpiGetGroupByEnum];
/**
 * @export
 */
export const KpiGetColumnsEnum = {
  AverageHarvestWeight: 'averageHarvestWeight',
  ClosingBiomass: 'closingBiomass',
  Days: 'days',
  FeedAmount: 'feedAmount',
  FeedCost: 'feedCost',
  HarvestWeight: 'harvestWeight',
  InputBiomass: 'inputBiomass',
  InputCount: 'inputCount',
  InputWeight: 'inputWeight',
  NetGrowth: 'netGrowth',
  HarvestSizeDistribution: 'harvestSizeDistribution',
  HarvestCount: 'harvestCount',
  HarvestVolumeEbit: 'harvestVolumeEbit',
  HarvestVolumeHog: 'harvestVolumeHog',
  HarvestVolumeLwe: 'harvestVolumeLwe',
  HarvestWeightHog: 'harvestWeightHog',
  HarvestWeightLwe: 'harvestWeightLwe',
  MabUtilization: 'mabUtilization',
  MortalityCount: 'mortalityCount',
  Turnover: 'turnover',
} as const;
export type KpiGetColumnsEnum = (typeof KpiGetColumnsEnum)[keyof typeof KpiGetColumnsEnum];
/**
 * @export
 */
export const MABUtilizationGetGroupByEnum = {
  Day: 'day',
  Week: 'week',
  Month: 'month',
  Quarter: 'quarter',
  Year: 'year',
} as const;
export type MABUtilizationGetGroupByEnum =
  (typeof MABUtilizationGetGroupByEnum)[keyof typeof MABUtilizationGetGroupByEnum];
/**
 * @export
 */
export const MABUtilizationGetColumnsEnum = {
  AverageHarvestWeight: 'averageHarvestWeight',
  ClosingBiomass: 'closingBiomass',
  Days: 'days',
  FeedAmount: 'feedAmount',
  FeedCost: 'feedCost',
  HarvestWeight: 'harvestWeight',
  InputBiomass: 'inputBiomass',
  InputCount: 'inputCount',
  InputWeight: 'inputWeight',
  NetGrowth: 'netGrowth',
  HarvestSizeDistribution: 'harvestSizeDistribution',
  HarvestCount: 'harvestCount',
  HarvestVolumeEbit: 'harvestVolumeEbit',
  HarvestVolumeHog: 'harvestVolumeHog',
  HarvestVolumeLwe: 'harvestVolumeLwe',
  HarvestWeightHog: 'harvestWeightHog',
  HarvestWeightLwe: 'harvestWeightLwe',
  MabUtilization: 'mabUtilization',
  MortalityCount: 'mortalityCount',
  Turnover: 'turnover',
} as const;
export type MABUtilizationGetColumnsEnum =
  (typeof MABUtilizationGetColumnsEnum)[keyof typeof MABUtilizationGetColumnsEnum];
/**
 * @export
 */
export const MABUtilizationPerConcessionGetGroupByEnum = {
  Day: 'day',
  Week: 'week',
  Month: 'month',
  Year: 'year',
} as const;
export type MABUtilizationPerConcessionGetGroupByEnum =
  (typeof MABUtilizationPerConcessionGetGroupByEnum)[keyof typeof MABUtilizationPerConcessionGetGroupByEnum];
